<div class="clients-content">
    <div class="row">
        <div class="col-md-3">

        </div>
        <div class="col-md-9">
            <p class="desc">Join the list of clients who’ve partnered with us in web, marketing, and brand designs.</p>
            <div class="row border_complete desktop_v">
                <div class="col-md-6 p-0 inner_bor">
                    <img src="assets/Group 27.png" class="img_client" alt="">
                </div>
                <div class="col-md-6 p-0 inner_bor">
                    <img src="assets/Group 25.png" class="img_client" alt="">
                </div>
                <div class="col-md-6 p-0 inner_bor">
                    <img src="assets/Group 29.png" class="img_client" alt="">
                </div>
                <div class="col-md-6 p-0 inner_bor">
                    <img src="assets/Group 27.png" class="img_client" alt="">
                </div>
            </div>
            <div class="row mbl_v text-center">
                <img src="assets/client-mbl.png" class="client_img" alt="">
            </div>
        </div>
    </div>

</div>